import { LOCALE } from "core/interfaces";

export const useKind = () => {
	const route = useRoute();

	const validateRoute = () => {
		const { components, currentProduct } = useShopStore();

		const kind = components?.kinds.find((kind) => {
			const defaultTranslation = kind.translations?.find(translation => translation.locale === LOCALE.ENGLISH);

			return defaultTranslation?.namePlural.toLowerCase() === route.params.kind.toString();
		});

		if (!kind || (route.params.product && (kind.id !== currentProduct.kind.id))) {
			throw createError({ statusCode: 404 });
		}
	};

	return {
		validateRoute
	};
};
